const REGEX = /^0x[a-fA-F0-9]{40}$/;
export const PREFIXED_STRING_LENGTH = 42;
export function toEthereumAddress(str) {
    if (REGEX.test(str)) {
        return str.toLowerCase();
    }
    throw new Error(`not a valid Ethereum address: "${str}"`);
}
//# sourceMappingURL=EthereumAddress.js.map